import { getSortedI18nNamespaces } from '@/lib/i18n/get-sorted-I18n-namespaces';

const i18nNamespaces = getSortedI18nNamespaces([
    'common',
    'navigation',
    'terms',
]);

export type TermsConfig = {
  i18nNamespaces: typeof i18nNamespaces;
};

export const termsConfig: TermsConfig = {
  i18nNamespaces,
};